import React from "react";
import { Link } from "react-router-dom";
import './header.css';
import people from '../../assets/people.png'
import ride from '../../assets/ride.jpg'

const Header = ({ isLoggedIn }) => {
  return (
    <div className="sr-header">
      <div className="sr-header__top">
        <h1 className="sr-header__title">Let's Make Carpooling amazing and safe</h1>
        <p className="sr-header__subtitle">It is an initiative to make carpooling easy and secure. It provides an opportunity to commuters to connect and have safe rides with any hassle.</p>
      </div>

      <div className="sr-header__body">
        <div className="sr-header__cta">
          { isLoggedIn
            ?  <Link to="/"><button className="sr-header__btn">Check Rides</button></Link>
            :  <Link to="/login"><button className="sr-header__btn">Get Started</button></Link>
          }
        </div>

        <div className="sr-header__people">
          <img src={people} alt="" />
          <p>100+ people have requested access so far</p>
        </div>

        <div className="sr-header__image">
          <img src={ride} alt="carpooling" />
        </div>
      </div>
    </div>
  );
}

export default Header;
